import { ApiResourceMethod } from '@/api/api-requests-factory';
import { PaymentMethodCredentialsEntry } from '@/models/ps-management/ps-management.model';

export default class CreatePaymentMethodCredentialsRequest extends ApiResourceMethod<{}> {
  public perform(billingPaymentMethodId: string, data: PaymentMethodCredentialsEntry): Promise<{}> {
    return this.performer.request({ url: billingPaymentMethodId, data });
  }
}
